import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isNullOrEmpty } from "../../utils/isNullOrEmpty";
import { findActiveItem } from "./tableOfContents";
import { setActiveItem } from "../../features/tableOfContents/TableOfContentsSlice";

export function useActiveTocItem() {
  const dispatch = useDispatch();
  const { tableOfContents } = useSelector((state) => state.tableOfContents);

  useEffect(() => {
    const headings = document.querySelectorAll("h2.topicontainer");

    const observer = new IntersectionObserver(
      (entries) => {
        if (isNullOrEmpty(tableOfContents)) return;

        let activeItem;
        let closestEntry = null;
        let minDistance = Infinity;

        entries.forEach((entry) => {
          const rect = entry.target.getBoundingClientRect();
          const distance = Math.abs(rect.top);

          if (entry.isIntersecting) {
            const data = extractTocLookupKey(entry);
            activeItem = findActiveItem(tableOfContents, data);
          }

          if (rect.top < 0 && distance < minDistance) {
            closestEntry = entry;
            minDistance = distance;
          }
        });

        if (isNullOrEmpty(activeItem) && closestEntry) {
          const data = extractTocLookupKey(closestEntry);
          activeItem = findActiveItem(tableOfContents, data);
        }

        if (
          isNullOrEmpty(activeItem) &&
          !isNullOrEmpty(tableOfContents.children)
        ) {
          activeItem = tableOfContents.children[0];
        }

        dispatch(setActiveItem(activeItem));
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0, 1.0],
      },
    );

    headings.forEach((heading) => observer.observe(heading));

    return () => {
      headings.forEach((heading) => observer.unobserve(heading));
    };
  }, [tableOfContents]);
}

function extractTocLookupKey(entry) {
  return entry.target.hasAttribute("filePath")
    ? { filePath: entry.target.getAttribute("filePath") }
    : { title: entry.target.textContent.trim().toLowerCase() };
}